export const calculateExpression = (expression: string): number => {
  const formatted = expression.replace(/%/g, "/100");
  // eslint-disable-next-line no-eval
  return eval(formatted);
};
